<template>
  <main>
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <p class="h6 open-sans line-height-golden py-4">Her kan du se en oversigt over dine aflyste møder.</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="6" sm="12" v-for="item in items" :key="item.id" v-if="item.id_appointment_status_support === '1'">
          <!-- notifications in general -->
          <b-card class="border-dark p-0 sm-p-0 rounded" :bg-variant="item.id_appointment_status_support === '1' ? 'white' : 'outline-danger'" style="min-height:250px;">
          <!-- <b-card class="border-0 p-0 sm-p-0 rounded one-edge-shadow" :border-variant="item.id_appointment_status_support === '1' ? 'danger' : 'dark'" bg-variant="light"> -->
            <b-row>
              <b-col>
                <div class="border-danger text-danger p-2 rounded text-small">
                  <span class="el-icon-date mr-2"></span>
                  <!-- <div class="d-block">Dato</div> -->
                  <div class="d-inline-block">{{ moment(item.appointment_date).format('DD/MM/YY') }} {{ item.id_times }}</div>
                </div>
               <!--   -->
                <div class="line-height-golden pl-2" v-if="item.id_appointment_status_support === '1'">
                  <b-button @click="showMeetingDetailsAflysetext(item)" v-if="item.ticketsolution !== ''" variant="link" class="p-0 font-weight-bold text-success">
                    <span class="el-icon-warning-outline float-left mr-2" style="font-size:16px;"></span>
                    {{ item.ticketcategory }}: {{ item.ticketstatus }}
                  </b-button>
                </div>
                <div class="line-height-golden pl-2">
                  <p v-if="item.ticketsolution === ''" class="font-weight-bold mb-0"><span class="el-icon-warning-outline float-left mr-2" style="font-size:16px;"></span>{{ item.ticketcategory }}: {{ item.ticketstatus }}</p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="text-dark p-2 text-small">
                  <span class="d-inline-block font-weight-bold">Kunde: </span>
                  <span class="d-inline-block">{{ item.firstname }}{{ item.lastname }}</span>
                </div>
                <div class="text-dark pl-2 pb-2">
                  <span class="d-inline-block font-weight-bold">Sted: </span>
                  <span class="text-small d-inline-block">{{ item.mailingstreet }} {{ item.mailingcity }} {{ item.mailingzip }}</span>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <!-- <div class="line-height-golden" v-if="item.id_appointment_status_support === '1'">
                  <b-button @click="showMeetingDetailsAflysetext(item)" v-if="item.ticketsolution !== ''" variant="dark" class="rounded">{{ item.ticketcategory }}: {{ item.ticketstatus }}</b-button>
                  <p v-if="item.ticketsolution === ''" class="font-weight-bold text-secondary">{{ item.ticketcategory }}: {{ item.ticketstatus }}</p>
                </div> -->
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div class="p-2">
                  <b-button :href="item.potentialnameurl" target="_blank" v-if="item.potentialnameurl !== ''" variant="dark" class="rounded font-weight-bold">
                    <span class="mr2">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/></svg></span>Prisoverslag
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-modal centered v-model="modalShowAflyseText" hide-footer :title="AflyseTexttitle">
          <div slot="modal-header-close">
            <span class="el-icon-error"></span>
          </div>
          <div class="open-sans line-height-golden h6">
            {{ AflyseText }}
          </div>
        </b-modal>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-container>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  name: 'cancellation',
  components: {
    loading,
    Simplert
  },
  created () {
    this.Reload()
  },
  data () {
    return {
      items: [],
      show: false,
      label: 'Loading...',
      AflyseText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: true,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      salesPerson: '',
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'YYYY-MM-DD',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        // debug: true
        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        // debug: true
        showClear: false,
        showClose: false
      }
    }
  },
  computed: {
    TopItem: function () {
    }
  },
  methods: {
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '2'}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res.array
          },
          response => {
            alert('error')
          }
        )
    },
    showMeetingDetailsAflysetext (item) {
      this.modalShowAflyseText = true
      this.AflyseText = item.ticketsolution
      this.AflyseTexttitle = item.ticketstatus
    },
    hideModal () {
      this.$refs.meetingModal.hide()
    }
  }
}
</script>
<style scoped>
.card-header {
  border-top: 0;
  border-bottom: 0;
  font-weight: 700;
}
.modal-header {
  border-bottom: 0;
}
.modal-title {
  font-weight: 700;
}
.card-columns > div > .card-header {
}
@media screen and (max-width: 640px) {
  .card {
    min-width: 100%;
    margin-bottom: 24px;
  }
}
</style>


// WEBPACK FOOTER //
// CancellationsTable.vue?6ea68f27